import React from 'react';
import axios from 'axios';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import url from '../../config/url';
var dropdownObj = {};
var dropdownData = [];
var swapDropdownData = [];
var batchTypeId = 0;
class SendDropdown extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            data:[],
            branch: new Array(),
            allBranches:new Array(),
            value1:'',
            value2:'',
            value3:'',
            clearable:true,
            showNewBranchDD:false,
            value3:''
            
        }
        this.handleDDChange = this.handleDDChange.bind(this)
        this.handleNewDDChange = this.handleNewDDChange.bind(this)
        this.handleSelectBranch = this.handleSelectBranch.bind(this);
        // this.appendSelect = this.appendSelect.bind(this);
    }

    handleSelectBranch(e){
        
        this.setState({value1:e.value});
        if(e.value === "swap"){
            this.setState({showNewBranchDD:true})
            // if(swapDropdownData.length === 0){
            //     axios.get(url + 'getBranchesForSwapBook').then(response=>{
            //         // console.log('swap books data',response.data)
            //         if(response.data.status){
            //             var data = response.data.successObject;
            //             data.forEach(element => {
            //                 var obj = {value:element.id,label:element.id  + '-'+element.branchName}
            //                 swapDropdownData.push(obj);
            //             });
            //         }
            //     }).catch(err =>{
            //         console.log(err)
            //     })
            // }
    
            // this.setState({allBranches:swapDropdownData});
        }else{
            this.setState({showNewBranchDD:false})
        }
        
    }

    handleNewDDChange(value){
        this.setState({value3:value})
        this.props.callback2(value,this.state.value1)
    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.state.data !== nextState.data){
            return true;
        }
        else if(this.state.branch !== nextState.branch){
            return true;
        }
        else if((this.state.value1 !== nextState.value1) ||(this.state.value2 !== nextState.value2) || (this.state.value3 !== nextState.value3)){
            return true;
        }
        else{
            return false;
        }
    }

    componentDidMount(){
        //api call to populate dropdown
        var branchId = sessionStorage.getItem('at');

        // var branchId = 45;
        // console.log('branchId isa ',branchId);
        if(swapDropdownData.length === 0){
            axios.get(url + 'getAllIbtBatchesKiosk').then(response=>{
                if(response.data.status){
                    var data = response.data.successObject;
                    console.log(data)
                    data.forEach(element => {
                        // batchTypeId = (element.name == "SENDOUT")?element.id:0;
                        if(element.name === 'SENDOUT'){
                            // console.log(element.id)
                            batchTypeId = element.id
                        }

                    });
                    this.props.getBatchType(batchTypeId);
                    return;

                }
            }).catch(err =>{
                console.log(err)
            })

            axios.get(url + 'getBranchesForSwapBook').then(response=>{
                // console.log('swap books data',response.data)
                if(response.data.status){
                    var data = response.data.successObject;
                    data.forEach(element => {
                        var obj = {value:element.id,label:element.id  + '-'+element.branchName}
                        swapDropdownData.push(obj);
                    });
                }
            }).catch(err =>{
                console.log(err)
            })
            
    

            // axios.get(url + 'getAllActiveBranchesKiosk').then(response=>{
            //     if(response.data.status){
            //         var data = response.data.successObject;
            //         data.forEach(element => {
            //             var obj = {value:element.id,label:element.id  + '-'+element.branchName}
            //             dropdownData.push(obj);
            //         });
            //     }
            // }).catch(err =>{
            //     console.log(err)
            // })

        }
        this.setState({allBranches:swapDropdownData});

        // this.setState({branch:dropdownData});

        
    }

    handleDDChange(value){
        // console.log('value is ',value)
        this.setState({value2:value})
        this.props.callback(value,this.state.value1)
    }

    render(){
        const { allBranches } = this.state;
        return(
            <React.Fragment>
                <div className="row" style = {{marginTop:30}}>
                    <div className="col-sm-3">
                        <Select
                            name="form-field-name"
                            onChange={this.handleSelectBranch}
                            value = {this.state.value1}
                            options={[
                            { value: 'rotation', label: 'Rotation Of Books' },
                            { value: 'swap', label: 'Swap Books' },
                            { value: 'newBook', label: 'New Books' },
                            { value: 'sellOff', label: 'Sell Off' },
                            { value: 'viaCluster', label: 'Via Cluster' },
                            ]}
                            searchable = {true}             
                            clearable={false}

                        />
                    </div>
                    <div className="col-sm-3">
                        <Select style = {{marginBottom:5}}
                            name="target-branch"
                            value = {this.state.value2}
                            clearable={false}
                            options={allBranches}
                            onChange = {this.handleDDChange}                            
                            placeholder='Select Branch..'
                            
                        />
                        {/* onChange = {value => this.setState({value2: value })}                             */}

                    </div>
                    {(this.state.showNewBranchDD) ? <div className="col-sm-3">
                        <Select
                            name="owner-branch"
                            value = {this.state.value3}
                            onChange = {this.handleNewDDChange}
                           
                            options={allBranches}
                            clearable={false}
                            placeholder='Select New Original Branch..'
                        />
                    </div>:''}
                    
                    <div className="col-sm-3"></div>
                </div>
            </React.Fragment>
            
        )
    }
}

export default SendDropdown;


// WEBPACK FOOTER //
// ./src/Components/Sending-Out/sendDropdown.js